import React, { useContext } from 'react'
import { ShareHelper } from '../helpers';
import { SettingsContext } from '../contexts/index.jsx';
import { Button } from './ui';

const EnquireButton = ({ whatsAppEnquireMessage, variant = "primary" }) => {
  const { settings } = useContext(SettingsContext);

  const onClick = (e) => {
    e.preventDefault()
    // De-DAO: use the store's support WhatsApp number, falling back to the
    // legacy DAO number so the link never breaks.
    ShareHelper.whatsapp(whatsAppEnquireMessage, settings?.support_whatsapp || "+447507709035")
  }

  return (
    <Button variant={variant} onClick={onClick} data-btn="listing-enquire">
      Enquire
    </Button>
  );
}

export default EnquireButton;
